import { render } from "./guide-hub-sidecontent.vue?vue&type=template&id=9566bf30"
import script from "./guide-hub-sidecontent.js?vue&type=script&lang=js"
export * from "./guide-hub-sidecontent.js?vue&type=script&lang=js"

import "./guide-hub-sidecontent.vue?vue&type=style&index=0&id=9566bf30&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__